export interface Entry {
  article: { item: Article; itemId: string };
  name: string;
  amount: number;
  lastAdded: Date;
  lastUsed: Date;
  bestBefore: Date;
}

export interface LogEntry {
  action: string;
  changedItem: Entry;
  created: Date;
}

export interface Recipe {
  title: string;
  durationInMin: number;
  weightInGramm: number;
}

export interface Article {
  name: string;
  type: ArticleType;
}

export interface DBEntry {
  createdBy: { timestamp: Date; username: string };
  item: Object;
  itemId: string;
}

export interface DBInventoryEntry {
  createdBy: { timestamp: Date; username: string };
  item: Entry;
  itemId: string;
}

export interface DBArticleEntry {
  createdBy: { timestamp: Date; username: string };
  item: Article;
  itemId: string;
}

export enum FormType {
  ADD = "add",
  USE = "use",
  DELETE = "delete",
  ADJUST = "adjust",
}

export enum DatabaseName {
  INVENTORY = "inventory",
  INVENTORYLOG = "logs",
  ARTICLES = "articles",
  RECIPE = "recipe",
}

export enum ArticleType {
  MEHL = "Mehl",
  SAUERTEIG = "Sauerteig",
  SONSTIGE = "Sonstige",
}

export enum ActionType {
  ADD,
  UPDATE,
  DELETE,
  ADJUST,
}
